import { KeyedItem } from './keyedItem';
import { ComputedQueryFull } from './computedQuery';

export interface ActionMove<T> extends ActionMoveBase<T> {
  filtersKeyHash: string;
  query: ComputedQueryFull<{}>;
}

export interface ActionMoveBase<T> {
  moveId: string;
  from: KeyedItem<T>;
  after: KeyedItem<T> | null | undefined;
  over: KeyedItem<T>;
  isFromHandle: boolean;
}
